import * as React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function InformationBlock() {
  return <section data-section-id="186165" id="article-body" className="bg-background px-4 sm:px-6 md:px-8 py-12 sm:py-16 md:py-20 lg:py-24">
      <div className="container mx-auto px-6 md:px-8 max-w-6xl flex flex-col">
        {}
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-8 tracking-tight">
          Pernyataan Resmi & Klarifikasi Detail
        </h2>

        {}
        <div className="flex flex-col gap-4 sm:gap-5 md:gap-6 text-base sm:text-lg md:text-xl leading-relaxed text-foreground font-sans">
          <p>
            Selamat datang di kanal klarifikasi resmi kami. Di sini Anda akan menemukan penjelasan mendalam dan fakta-fakta penting yang disusun untuk meluruskan informasi yang beredar. Kami menjunjung tinggi transparansi dalam setiap pemberitaan demi kepentingan publik. Untuk rujukan lebih spesifik, silakan tinjau{" "}
            <Link to="#" className="text-secondary underline hover:text-secondary/80 transition-colors">
              arsip klarifikasi
            </Link>{" "}
            kami yang mencakup dokumentasi teknis dan bukti pendukung secara lengkap.
          </p>
          
          <p className="italic text-2xl bg-muted border-l-4 border-primary text-foreground">
            Harap dicatat bahwa seluruh pernyataan dalam dokumen ini telah melalui proses verifikasi ketat sesuai dengan standar jurnalisme profesional dan kode etik pers yang berlaku saat ini.
          </p>
          
          <p>
            Dedikasi kami terhadap kebenaran informasi adalah fondasi utama layanan ini. Baik Anda pembaca setia yang mencari fakta maupun pihak yang berkepentingan, bagian ini berfungsi sebagai referensi utama untuk menghindari disinformasi. Jika Anda memerlukan bantuan lebih lanjut atau ingin memberikan tanggapan, tim redaksi kami siap membantu memberikan klarifikasi atas segala keraguan yang muncul.
          </p>
        </div>

        {}
        <div className="py-4 sm:py-6 md:py-8 mt-2">
          <Separator className="bg-border" />
        </div>
      </div>
    </section>;
}